export const carouselButtonLabels = ['previous', 'next'] as const;
export const defaultScrollDistance = 270; // The smallest card width, in pixels, shown in the mock-
